import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IValueState } from '@hooks/useValueState';
import { Box, Card, CardContent, CardHeader, CircularProgress, Typography } from '@material-ui/core';
import { IRelatorioStatusLinhaSummary } from '@services/RelatorioService';
import React from 'react';

export type RelatorioStatusLinhaCardsProps = {
    isClienteLoadingSummary: boolean
    isFuncionarioLoadingSummary: boolean
    isSemContratoLoadingSummary: boolean

    cliente: IValueState<IRelatorioStatusLinhaSummary>
    funcionario: IValueState<IRelatorioStatusLinhaSummary>
    semContrato: IValueState<IRelatorioStatusLinhaSummary>
}

export function RelatorioStatusLinhaCards ({ isClienteLoadingSummary, isFuncionarioLoadingSummary, isSemContratoLoadingSummary, cliente, funcionario, semContrato }: RelatorioStatusLinhaCardsProps) {
    return (
        <Box style={{marginTop: 24, marginBottom: 24}}>
            <HorizontalGrid spacing={2}>
                <GridItem xs={4}>
                    <Card elevation={15}>
                        <CardHeader title="Com Clientes" />
                        <CardContent>
                            {
                                isClienteLoadingSummary
                                ? <Box style={{textAlign: 'center'}}><CircularProgress /></Box>
                                : <Typography variant="h3">{cliente.value?.count ?? 0}</Typography>
                            }
                        </CardContent>
                    </Card>
                </GridItem>
                
                <GridItem xs={4}>
                    <Card elevation={15}>
                        <CardHeader title="Com Funcionário" />
                        <CardContent>
                            {
                                isFuncionarioLoadingSummary
                                ? <Box style={{textAlign: 'center'}}><CircularProgress /></Box>
                                : <Typography variant="h3">{funcionario.value?.count ?? 0}</Typography>
                            }
                        </CardContent>
                    </Card>
                </GridItem>

                <GridItem xs={4}>
                    <Card elevation={15}>
                        <CardHeader title="Sem Contrato" />
                        <CardContent>
                            {
                                isSemContratoLoadingSummary
                                ? <Box style={{textAlign: 'center'}}><CircularProgress /></Box>
                                : <Typography variant="h3">{semContrato.value?.count ?? 0}</Typography>
                            }
                        </CardContent>
                    </Card>
                </GridItem>
            </HorizontalGrid>
        </Box>
    )
}